import { IncomingMessage } from 'http';

export function getClientIp(req: IncomingMessage): string | undefined {
	const forwardedFor = req?.headers['x-forwarded-for'];
	if (Array.isArray(forwardedFor)) {
		return forwardedFor[0];
	}
	return forwardedFor || req?.connection?.remoteAddress;
}
